export const AGORA_APP_ID = process.env.REACT_APP_AGORA_APP_ID;

export const AGORA_APP_CERTIFICATE =
  process.env.REACT_APP_AGORA_APP_CERTIFICATE;

export const COFFEE_CALL_DUMMY_CHANNEL = "123456";

export const REACT_APP_NOTIFICATION_VAPID_KEY =
  process.env.REACT_APP_NOTIFICATION_VAPID_KEY;

export const AGORA_RTM_APP_ID = process.env
  .REACT_APP_AGORA_RTM_APP_ID as string;
export const REACT_APP_API_BASE_URL = process.env
  .REACT_APP_API_BASE_URL as string;

// Zego Cloud Configuration
export const ZEGO_APP_ID = process.env.REACT_APP_ZEGOCLOUD_APP_ID;
export const ZEGO_APP_SIGN = process.env.ZEGOCLOUD_SERVER_SECRET || "YOUR_APP_SIGN";
export const ZEGO_SERVER_ENV = process.env.REACT_APP_ZEGO_SERVER_ENV === 'true' || true;
export const ZEGOCLOUD_ROOM_URL = process.env.REACT_APP_ZEGOCLOUD_ROOM_URL || "";

// Optional: backend URL that returns CORS-enabled audio for a YouTube URL (e.g. ?url=...).
// Required for Sing4You when using YouTube links; direct audio URLs work without it.
export const YOUTUBE_AUDIO_PROXY = process.env.REACT_APP_YOUTUBE_AUDIO_PROXY || "";
